import { render, staticRenderFns } from "./wordAudioPic.vue?vue&type=template&id=4b8b315c&scoped=true&"
import script from "./wordAudioPic.vue?vue&type=script&lang=js&"
export * from "./wordAudioPic.vue?vue&type=script&lang=js&"
import style0 from "./wordAudioPic.vue?vue&type=style&index=0&id=4b8b315c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b315c",
  null
  
)

export default component.exports